import { computed } from 'vue';
import { useOrganizationStore } from '../stores/organization';

// Angular ModuleService.isModuleEnabled$ reads `loginOrganization$`, not `organization$` — the
// config/white-label fallback has no `availableModules` at all, so checking it reports every module
// as disabled until initApp() has replaced it.
export function useModuleEnabled(module: string) {
    const orgStore = useOrganizationStore();
    return computed(
        () => orgStore.loginOrganization?.availableModules?.map((m) => m.toLowerCase()).includes(module.toLowerCase()) ?? false,
    );
}
